/**
 * Formatting number into string where thousands are separated by spaces - ' '
 * Limiting and expanding decimals to 2 digits after comma.
 * @param {number} number Number to be formatted
 */
export function toCurrencyString(number) {
  if (typeof number !== 'number' || number < 0) return '***';
  return (
    '$' +
    number
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      .replace(/(?=\.\d{3,})(\.\d{2})\d*/, '$1')
      .replace(/(\.\d)$/, '$10')
  );
}
